import { MSCalendar } from "../..";
import styles from "../styles.css";
import { IExclude } from "@lib/store/src/calendar";

import { getNewTemplate } from "./add-exception.templates";
import { ExceptionModal } from "./exception";

/**
 * Добавление исключения (расширение ExceptionModal class)
 * @class AddWeekModal
 * @extends ExceptionModal
 * @classdesc AddWeekModal
 * */
export class AddExceptionModal extends ExceptionModal {
  constructor(rootID: string, root: MSCalendar) {
    super(rootID, root);
    super.init(getNewTemplate(), styles);
  }

  /**
   * Инициализация обработчиков событий
   */
  onStartup() {
    const modal = this.popup.modalComponent;

    modal.addEventListener("click", (e) => {
      const target = e.target as HTMLElement;

      // Обработка кнопки "Добавить"
      if (target.closest("#submit")) {
        this.submit();
      }

      // Обработка кнопки "Сбросить"
      if (target.closest("#reset")) {
        this.close();
      }

      // Обработка кнопки "Добавить событие"
      if (target.closest("#add-event")) {
        this.addEventTime();
        this.validateForms();
      }
    });

    this.bodyEvents?.addEventListener("click", (e) => this.onClickEvent(e));
  }

  /**
   * Обработчик кнопки сохранения нового расписания
   * */
  submit() {
    if (!this.isValidForm()) return;
    if (!this.isValidPeriodForm()) return;

    const period = this.selectHelper.getFormValues();
    const newExcludeSchedule: Array<IExclude> = JSON.parse(
      JSON.stringify(this.root.store.excludeSchedule)
    );

    if (this.eventsState.length > 0) {
      this.eventsState.forEach((event) => {
        newExcludeSchedule.push({
          ...event,
          period,
          priority: Number(this.priority.value),
        });
      });

      this.store.onChange("excludeSchedule", newExcludeSchedule);

      this.root.saveException();
    }

    this.close();
  }

  /**
   * Переключение видимости модального окна
   */
  toggle() {
    this.popup.modalComponent.toggle();
    if (!this.popup.modalComponent.active) return;
  }

  /**
   * Открытие модального окна
   */
  open() {
    this.popup.modalComponent.open();

    this.resetForm(); // Сброс формы
    this.popup.uiModal.resetSize();

    this.validateForms();
  }

  /**
   * Закрытие модального окна
   */
  close() {
    this.popup.modalComponent.close();
  }
}
